import React, { useState } from 'react';
import QuickActionsSidebar from '../pages/DistributorDashboard/QuickActionsSidebar';
import Top from '../pages/Top';
import { useQuickActions } from '../../hooks/useQuickActions';
import './PageLayout.css';

const PageLayout = ({ children, className = '', purchaseCallback = null }) => {
  const [expandedMenu, setExpandedMenu] = useState(null);
  const quickActions = useQuickActions(purchaseCallback);

  return (
    <div className={`page-layout-wrapper ${className}`}>
      <Top />
      <div className="page-layout-container">
        <QuickActionsSidebar
          actions={quickActions}
          expandedMenu={expandedMenu}
          setExpandedMenu={setExpandedMenu}
        />
        <div className="page-layout-content">
          {children}
        </div>
      </div>
    </div>
  );
};

export default PageLayout;
